import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "clearButton"]
  static values = { url: String, loading: String, error: String }

  connect() {
    this.updateClearButton()
  }

  updateClearButton() {
    if (this.hasClearButtonTarget) this.clearButtonTarget.hidden = !this.inputTarget.value.trim()
  }

  disconnect() {
    clearTimeout(this.timer)
    this.request?.abort()
    this.request = null
  }

  schedule() {
    this.updateClearButton()
    clearTimeout(this.timer)
    this.request?.abort()
    this.timer = setTimeout(() => this.preview(), 350)
  }

  clear() {
    this.disconnect()
    this.inputTarget.value = ""
    this.updateClearButton()
    this.previewTarget.replaceChildren()
    this.previewTarget.removeAttribute("aria-busy")
    this.inputTarget.focus()
  }

  async preview() {
    if (!this.inputTarget.value.trim()) {
      this.previewTarget.replaceChildren()
      return
    }
    const request = new AbortController()
    this.request = request
    this.previewTarget.textContent = this.loadingValue
    this.previewTarget.setAttribute("aria-busy", "true")
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        credentials: "same-origin",
        signal: request.signal,
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: JSON.stringify({ shared_link: this.inputTarget.value })
      })
      const html = await response.text()
      if (request !== this.request || request.signal.aborted) return
      if (response.redirected) throw new Error("Unexpected redirect")
      if (response.ok) this.previewTarget.innerHTML = html
      else this.previewTarget.textContent = response.status === 422 ? html : this.errorValue
    } catch (error) {
      if (request === this.request && error.name !== "AbortError") this.previewTarget.textContent = this.errorValue
    } finally {
      if (request === this.request) this.previewTarget.removeAttribute("aria-busy")
    }
  }
}
